import { PUBLIC_ROUTE } from "@src/route.constants";
import { smoothScroll } from "@utils/helpers/smoothScroll";
import { setupLoanRoute } from "@utils/helpers/navigators";
import { VERIFY_ROUTES } from "@constants/commonConstants";

const thankYouRoute = PUBLIC_ROUTE.THANK_YOU;

const shouldRouteBeActive = (loanFormState) => {
  const { isFormCompleted } = loanFormState || {};
  const { loanStatus } = loanFormState || {};
  const { nextScreen } = loanFormState.verify || {};
  const isFormProcessing = loanStatus === null && nextScreen === VERIFY_ROUTES.THANK_YOU;

  return isFormCompleted || isFormProcessing;
}

const navigateTo = (navigate) => {
  navigate(thankYouRoute + window.location.search);
  smoothScroll();
};

export const thankYouNavigation = setupLoanRoute({shouldRouteBeActive, navigateTo});